import axios from "axios";

const api_url = process.env.REACT_APP_API_URL + "/login";

export async function login(data) {
    try {
        let resp = await axios.post(api_url,data);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            message: null
        }
        if (err.response) {
            let status = err.response.status;
            if (status===400) {
                resp.message = err.response.data.mensaje;
            } else {
                resp.message = "Hubo un error al autenticar el usuario en el servidor.";
            }
            //develver error segun estado
        } else {
            resp.message ="Hubo un error al intentar conectar con el servidor.";
            //develver error de red
        }
        return resp;
    }
}